import {
  ID_NOTIFY_BUTTON,
  ID_POPUP,
  ID_SUBMIT_BUTTON,
  ID_SUCCESS_BANNER,
  ID_SUCCESS_BANNER_ICON,
  ID_SUCCESS_BANNER_TEXT,
  SELECTOR_POPUP_DESCRIPTION,
  SELECTOR_POPUP_TITLE,
} from '../constants';

/**
 * @type {import('../index.d').applyDynamicStyling}
 */
export function applyDynamicStyling(context) {
  const displaySettings = context.app?.backInStock?.displaySettings || {};

  const notifyButton = document.getElementById(ID_NOTIFY_BUTTON);
  const popup = document.getElementById(ID_POPUP);
  const submitButton = document.getElementById(ID_SUBMIT_BUTTON);

  if (displaySettings.button && notifyButton) {
    notifyButton.style.color = displaySettings.button.textColor;
    notifyButton.style.backgroundColor = displaySettings.button.backgroundColor;
    notifyButton.textContent = displaySettings.button.buttonText || 'Notify me when available';
  }

  if (displaySettings.signUpForm && popup) {
    const popupTitle = popup.querySelector(SELECTOR_POPUP_TITLE);
    const popupDescription = popup.querySelector(SELECTOR_POPUP_DESCRIPTION);

    if (popupTitle) {
      popupTitle.textContent = displaySettings.signUpForm.header || 'Notify me';
    } else {
      console.warn('Popup title not found.');
    }

    if (popupDescription) {
      popupDescription.textContent =
        displaySettings.signUpForm.description ||
        'Get a notification as soon as this product is back in stock by signing up below!';
    }
  }

  if (displaySettings.signUpForm && submitButton) {
    submitButton.textContent = displaySettings.signUpForm.buttonText || 'Notify me when available';
    submitButton.style.color = displaySettings.signUpForm.textColor;
    submitButton.style.backgroundColor = displaySettings.signUpForm.backgroundColor;
  }

  if (displaySettings.confirmationMessage) {
    const successBanner = document.getElementById(ID_SUCCESS_BANNER);
    const successBannerText = document.getElementById(ID_SUCCESS_BANNER_TEXT);
    const successBannerIcon = document.getElementById(ID_SUCCESS_BANNER_ICON);

    if (successBannerText) {
      successBannerText.textContent =
        displaySettings.confirmationMessage.message ||
        'We will notify you when the item is available';
      successBannerText.style.color = displaySettings.confirmationMessage.textColor;
    }

    if (successBanner) {
      successBanner.style.backgroundColor = displaySettings.confirmationMessage.backgroundColor;
    }

    if (successBannerIcon) {
      successBannerIcon.style.fill = displaySettings.confirmationMessage.iconColor;
    }
  }
}
